import React, { useLayoutEffect } from 'react';
import CommonButton from '../../Components/CommonButton';
import { useNova } from '../NovaContext';
import { MAX_QUESTION_LENGTH, NOVA_IDS } from '../constants';
import { IconArrowUp } from '../icons';
import { T } from './Text';

const MAX_LINES = 5;

const placeholderFor = (tab, hasMessages, outOfCredits) => {
    if (outOfCredits) return 'No credits left';
    if (tab === 'insights') return 'Ask about these insights…';
    return hasMessages ? 'Ask a follow-up…' : 'Ask about risks, threats or reports…';
};

export default function Composer() {
    const { state, actions, refs } = useNova();
    const tab = state.activeTab;
    const draft = state.drafts[tab];
    const outOfCredits = state.credits === 0;
    const canSend = draft.trim().length > 0 && !state.sending && !outOfCredits;

    useLayoutEffect(() => {
        const el = refs.inputRef.current;
        if (!el) return;
        el.style.height = 'auto';
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20;
        el.style.height = `${Math.min(el.scrollHeight, lineHeight * MAX_LINES)}px`;
    }, [draft, tab, state.open, refs.inputRef]);

    const submit = () => {
        if (!canSend) return;
        actions.setDraft(tab, '');
        actions.send(draft);
    };

    const onKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
            event.preventDefault();
            submit();
        }
    };

    return (
        <div className="nova_composer">
            <div className="nova_composer_row">
                <T as="label" htmlFor={NOVA_IDS.input} className="nova_sr">Message Foresee AI</T>
                <textarea
                    ref={refs.inputRef}
                    id={NOVA_IDS.input}
                    rows={1}
                    maxLength={MAX_QUESTION_LENGTH}
                    className="nova_input"
                    value={draft}
                    disabled={outOfCredits}
                    placeholder={placeholderFor(tab, state.messages.length > 0, outOfCredits)}
                    onChange={(event) => actions.setDraft(tab, event.target.value)}
                    onKeyDown={onKeyDown}
                />
                <CommonButton
                    type="button"
                    className="nova_send"
                    aria-label="Send message"
                    disable={!canSend}
                    onClick={submit}
                    text={<IconArrowUp size={18} />}
                />
            </div>
            {outOfCredits ? (
                <T as="p" size="sm" className="nova_footer nova_danger" role="alert">
                    You have used all your credits. Please upgrade your plan.
                </T>
            ) : (
                <div className="nova_meta">
                    <T size="sm" className="nova_muted">{state.credits !== null && `${state.credits} credits left`}</T>
                    <T size="sm" className="nova_muted">{draft.length > 0 && `${draft.length}/${MAX_QUESTION_LENGTH}`}</T>
                </div>
            )}
            <T as="p" size="sm" className="nova_footer">Powered by Foresee AI · Verify critical findings before acting</T>
        </div>
    );
}
